<template>
  <component
    :is="tag"
    class="auth-login__btn"
    :class="btnClass"
    :type="tag === 'button' ? type : undefined"
    :href="tag === 'a' ? href : undefined"
    :disabled="tag === 'button' ? (disabled || loading) : undefined"
    :aria-busy="loading ? 'true' : undefined"
    :aria-label="ariaLabel || undefined"
    @click="onClick"
  >
    <AuthIcon v-if="icon" :name="icon" />
    <slot />
    <AuthIcon v-if="trailingIcon" :name="trailingIcon" />
  </component>
</template>

<script setup>
import { computed } from 'vue'
import AuthIcon from './AuthIcon.vue'

const props = defineProps({
  variant:      { type: String, default: 'primary' },
  type:         { type: String, default: 'button' },
  loading:      { type: Boolean, default: false },
  disabled:     { type: Boolean, default: false },
  href:         { type: String, default: '' },
  icon:         { type: String, default: '' },
  trailingIcon: { type: String, default: '' },
  ariaLabel:    { type: String, default: '' },
})

const emit = defineEmits(['click'])

const tag = computed(() => (props.href ? 'a' : 'button'))

const btnClass = computed(() => ({
  'auth-login__btn--primary': props.variant === 'primary',
  'auth-login__btn--outline': props.variant === 'outline' || props.variant === 'secondary',
  'auth-login__btn--ghost':   props.variant === 'link' || props.variant === 'ghost',
  'auth-login__btn--loading': props.loading,
}))

const onClick = (e) => {
  if (!props.loading && !props.disabled) {
    emit('click', e)
  }
}
</script>
